import type { LanguageOption } from '../api/generated';
import { SelectMenu } from './SelectMenu';

export interface LanguageSelectProps {
  readonly value: string;
  readonly options: readonly LanguageOption[];
  readonly onChange: (language: string) => void;
  readonly disabled?: boolean;
}

/** Picks one of the languages the backend supports. */
export function LanguageSelect({ value, options, onChange, disabled = false }: LanguageSelectProps) {
  return (
    <SelectMenu
      label="Language"
      value={value}
      options={options.map((option) => ({ value: option.id, label: option.label }))}
      onChange={onChange}
      disabled={disabled}
    />
  );
}
